import { Pipe, PipeTransform } from '@angular/core';
import { formQuestionTypeToName } from '../enum/FormQuestionTypes';

@Pipe({
  name: 'formQuestionType',
})
export class FormQuestionTypePipe implements PipeTransform {
  transform(value: any): any {
    return formQuestionTypeToName(value);
  }
}
